<template>
  <div>
    <PCMenu :memberSystem="company"/>
    <div class="main m-t-20">
      <div class="w1200 m-auto flex">
        <div class="left" :class="{'smallLeft':hideLeft}">
          <van-icon name="play" size="25" color="#45a4b6"
                    class="hdBtn" v-show="hideLeft"
                    @click="switchLeftMenu"></van-icon>
          <form class="layui-form" action="">
            <div class="searcharea flex" style="align-items: center">
              <div class=" flex" style="flex:1; flex-wrap: nowrap;">
                <input type="text" name="title" v-model="searchValue" @keyup.enter="onSearch" required
                       lay-verify="required" placeholder="关键词搜索" autocomplete="off" class="layui-input search">
                <i class="layui-icon layui-icon-search" style="color:#00139e" @click.stop="onSearch"></i>
              </div>
              <van-button plain type="button" hairline size="25" @click.prevent="switchLeftMenu" color="#45a4b6"
                          style="margin: 0 0 5px 15px;padding: 0 10px;">全屏
              </van-button>
            </div>
            <div class="m-t-20" style="background:#f6f6f6;">
              <ul class="filenav flex">
                <li v-show="!searching" @click="toggleTab(tab.id)" :class="tab.id==activeTab?'active':''" v-for="tab in list" :key="tab.id"
                    :value="tab.id">{{ tab.name }}
                </li>
                <li v-show="searching"  class="active" style="position: relative">
                  搜索结果
                  <i class="search-retbtn" @click="returnSearch">返回</i>
                </li>
              </ul>
              <div class="leftTree">
                <div v-if="false" class="ctrallBox">
                  <a style='cursor: pointer; ' @click="expandTree(true)">展开所有</a>
                  <a style='cursor: pointer; ' @click="expandTree(false)">收起所有</a>
                </div>
                <ul id="treeDemo" style="height : 600px;" class="ztree ta-l">
                </ul>
              </div>
            </div>
          </form>
        </div>
        <div class="right m-l-20 pdf">
          <div v-if="isPDF" class="tip">请点击阅读器最上面的“+”“-”进行缩放，点击 <img
              src="/plugin/pdfShow/web/images/toolbarButton-presentationMode.png"> 打开全屏
          </div>
          <div id='zhidangMs'></div>
          <iframe v-if="isPDF" v-preventright id="contentIframe" name="contentIframe" :src='pSrc'></iframe>
          <img v-if="!isPDF" v-preventright style="width:100%;" id="contentImg" :src="pSrc"/>
          <div class="alert" v-show="errorMessage">
            <div class="title">提示</div>
            <div>{{ errorMessage }}</div>
            <button class="close" @click="errorMessage=''">关闭</button>
          </div>
        </div>

      </div>
    </div>

    <!--    <PCCopyright />-->
  </div>
</template>


<script>
import PCMenu from "@/components/PCMenu.vue";
import PCCopyright from "@/components/PCCopyright.vue";
import {
  Get_Brand_Node_List,
  Get_File_Node_List,
  Is_Expire_Tips,
  Check_File_Url
} from "@/api/index";
import {Icon, Popup, Button} from "vant";

export default {
  name: "PDFShow",
  components: {
    PCMenu,
    PCCopyright,
    [Button.name]: Button,
    [Icon.name]: Icon,
  },
  data() {
    return {
      brandId:0,
      activeTab: 0,
      searchValue: "",
      list: [],
      searching:false,
      treeData: [],
      pSrc: "",
      isPDF: true,
      company: {},
      hideLeft: false,
      errorMessage: ''
    };
  },
  methods: {
    switchLeftMenu() {
      this.hideLeft = !this.hideLeft;
    },
    toggleTab: function (id) {
      this.activeTab = id;
      this.searchValue = "";
      this.treeData = this.loadNodeTree(this.list);
      this.loadFileNodeList(id);
      // this.loadTree();
    },
    async onSearch() {
      if (this.searchValue == "") {
        // this.layer.msg("请输入关键词");
        this.treeData = this.loadNodeTree(this.list);
      }
      this.loadFileNodeList(this.activeTab, true, true,true);
    },
    async returnSearch(){
      this.toggleTab( this.activeTab);
    },
    async getBrandNodeList() {
      var params = {
        id: this.brandId,
        depth: 6,
      };
      this.list = await Get_Brand_Node_List(params);
    },
    async getFileNodeList(id,isSearch) {
      var params = {
        id: isSearch?this.brandId:id,
        key: this.searchValue,
      };
      return await Get_File_Node_List(params);
    },
    async loadFileNodeList(id, spread, reload,isSearch) {
      var node = this.findNode(this.treeData, id);
      if (node) {
        if ((this.global.isNull(node.href) && !node.isLoad) || reload) {
          node.isLoad = true;
          var fileNodeList = await this.getFileNodeList(id,isSearch);
          fileNodeList = this.loadNodeTree(fileNodeList);
          if (!reload && Array.isArray(node.children)) {
            if (node.children.length == 1 && !node.children[0].id) {
              node.children = fileNodeList;
            } else node.children = node.children.concat(fileNodeList);
          } else {
            node.children = fileNodeList;
          }
          node.spread = true;
          this.loadTree();
        } else {
          node.spread = spread;
        }
      }
      this.searching = isSearch
    },
    // async loadData(id) {
    //   var treeNodeData = this.findNode(this.treeData, id);
    //   if (
    //     !this.global.isNull(treeNodeData) &&
    //     (!treeNodeData.isLoad || treeNodeData.isLoad)
    //   ) {
    //     if (this.list && this.list.length > 0) {
    //       var currentItem = this.findItem(this.list, id);
    //     }
    //     treeNodeData.isLoad = true;
    //   }
    // },
    // findItem: function (list, id) {
    //   list.forEach((e) => {
    //     if (e.id == id) {
    //       return e;
    //     }
    //     if (e.subList && e.subList.length > 0) {
    //       this.findItem(e.subList, id);
    //     }
    //   });
    // },
    loadNodeTree: function (list) {
      var result = [];
      if (list && list.length > 0) {
        list.forEach((e) => {
          var node = this.loadNode(e);
          if (!this.global.isNull(e.children) && e.children.length > 0) {
            node.children = this.loadNodeTree(e.children);
            // node.isLoad = true;
          } else if (!node.href) {
            node.children = [{title: "加载中..."}];
          }
          result.push(node);
        });
      }
      return result;
    },
    // loadNodeList: function (list) {
    //   var result = [];
    //   if (list && list.length > 0) {
    //     list.forEach((e) => result.push(this.loadNode(e)));
    //   }
    //   return result;
    // },
    loadNode: function (item) {
      var result = {};
      if (!this.global.isNull(item)) {
        result = {
          id: item.id,
          brandId: item.brandId,
          title: item.name,
          href: item.url,
          isLoad: false,
          children: [],
        };
      }
      return result;
    },
    findNode: function (list, id) {
      for (let i = 0; i < list.length; i++) {
        var m = list[i];
        if (m.id == id) {
          return m;
        }
        if (m.children && m.children.length > 0) {
          var node = this.findNode(m.children, id);
          if (node) {
            return node;
          }
        }
      }
    },
    expandTree: function (isExpend, list) {
      if (this.global.isNull(list)) {
        list = this.treeData;
      }
      this.expandAll(isExpend, list);
      this.loadTree();
    },
    expandAll: function (isExpend, list) {
      list.forEach((m) => {
        m.spread = isExpend;
        if (m.children && m.children.length > 0) {
          this.expandAll(isExpend, m.children);
        }
      });
    },
    async loadTree() {
      const _this = this;
      this.tree.render({
        id: "filetree",
        elem: "#treeDemo",
        onlyIconControl: true,
        data: _this.treeData.find((m) => m.id == _this.activeTab).children,
        click: async function (obj) {
          obj.data.spread = !obj.data.spread;
          var nodeObj = _this.$(obj.elem);
          nodeObj.toggleClass("layui-tree-spread");
          nodeObj.find(".layui-tree-pack").slideToggle();
          nodeObj
              .children()
              .first()
              .find("i.layui-icon")
              .toggleClass("layui-icon-addition")
              .toggleClass("layui-icon-subtraction");
          obj.state = obj.state == "close" ? "open" : "close";

          let type = 'ziliao';

          //说明是目录
          if (_this.global.isNull(obj.data.href) && !obj.data.isLoad) {
            _this.loadFileNodeList(obj.data.id);
            return;
          }

          if (!_this.global.isNull(obj.data.href)) {
            _this.$(".layui-tree-spread .layui-tree-txt").removeClass("nodecolor");
            nodeObj.find(".layui-tree-txt").addClass("nodecolor");

            let filePath = obj.data.href.replace(/\/file\//, "/file/");
            if (filePath.substring(filePath.length - 4) == ".pdf") {
              _this.isPDF = true;
            }else{
              _this.isPDF = false;
            }
            //检查权限，增加阅读记录，返回临时URL
            let pathRet = await Check_File_Url({
              id: obj.data.id,
              type: type,
              url: filePath,
              brandId: _this.brandId
            });
            console.log(pathRet)
            if (pathRet.resultType == -1) {
              _this.errorMessage = pathRet.message
              return;
            }
            filePath = pathRet.fileUrl

            if (_this.isPDF) {
              // _this.pSrc =
              //   "/plugin" +
              //   filePath +
              //   "&host=" +
              //   _this.global.APIBasePath +
              //   "&brandid=" +
              //   _this.brandId +
              //   "&token=" +
              //   localStorage.getItem("AccessToken");
              _this.pSrc = `/plugin/pdfShow/web/viewer.html?type=${type}&brandid=${_this.brandId}&file=${encodeURIComponent(filePath)}`;

            } else {
              // _this.pSrc =
              //   _this.global.APIBasePath +
              //   filePath +
              //   "?brandid=" +
              //   obj.data.brandId;
              // _this.isPDF = false;
              _this.pSrc = filePath;
            }
          }
        },
      });
    },
  },

  mounted() {
    const _this = this;
    _this.brandId = this.$route.params.id
    layui.use(["layer", "jquery", "tree"], async function () {
      var layer = layui.layer,
          $ = layui.jquery,
          tree = layui.tree;
      _this.tree = tree;
      _this.$ = $;
      _this.layer = layer;

      _this.company = await _this.global.getMemberSystem();

      await _this.getBrandNodeList();
      _this.treeData = _this.loadNodeTree(_this.list);
      // $(".filenav li").first().click();

      $("#treeDemo").on("click", "span.layui-tree-iconClick", function (event) {
        _this.loadFileNodeList(
            $(this).closest(".layui-tree-set").data("id"),
            $(this).find("i.layui-icon").hasClass("layui-icon-subtraction")
        );
      });

      //到期提醒
      Is_Expire_Tips().then((m) => {
        if (m) {
          layer.alert(
              "尊敬的用户，你的查询期限快要到期，请尽快前往续费或联系客服",
              {
                skin: "layer-ext-moon",
                title: "查询期限快到期提示",
              }
          );
        }
      });

      document.onkeypress = function (e) {
        var keycode = document.all ? event.keyCode : e.which;
        if (keycode == 13) {
          _this.onSearch();
          return false;
        }
      };
    });
  },
  watch: {
    list: function (val) {
      this.$nextTick(function () {
        this.$(".filenav li").first().click();
      });
    },
    "$route": function(val){
      this.brandId = val.params.id
    }
  },
  directives: {
    focus: {
      function(el) {
        el.focus();
      },
    },
  },
};
</script>
<style lang="css">
.pdf .alert {
  background: #FF5555;
  color: white;
  position: absolute;
  top: 100px;
  left: 60px;
  right: 60px;
  padding: 30px 80px;
  font-size: 18px;
  line-height: 30px;
  text-space: 1.5em;
}

.pdf .alert .title {
  font-size: 20px;
  margin-bottom: 20px;
}

.pdf .alert .close {
  margin-top: 50px;
  color: #333;
  font-size: 16px;
  padding: 2px 10px;
}
</style>
